import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const EqualsIcons = ({
  width = 17,
  height = 13,
  color = colors.madison,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M16.7656 0.827739L16.7811 4.83552L1.01362 
      4.89628L0.998181 0.888495L16.7656 0.827739ZM16.7949 
      8.42143L16.8103 12.4292L1.04288 12.49L1.02744 
      8.48219L16.7949 8.42143Z"
      fill={color}
    />
  </VectorIcon>
);

export default EqualsIcons;
